import React from 'react';
import TimeAgo from 'react-timeago'

type Props = {
  label?: string,
  name?: string,
  record?: any,
  source?: string
};

const DateField = (props: Props) => (
  <span>
    {props.record[props.name] && <TimeAgo date={props.record[props.name]} title={new Date(props.record[props.name]).toString()} />}
  </span>
);

export default DateField;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/DateField.tsx